// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left-right-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 11.5L19.5 7.50001L15.5 3.5M18.25 7.5H9.5M8.5 12.5L4.5 16.5L8.5 20.5M5.75 16.5H14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftRight3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left-right-3',
    ref,
    icon: element,
  },
));

ArrowLeftRight3Icon.displayName = 'ArrowLeftRight3Icon';

export default ArrowLeftRight3Icon;
